import React, { useEffect, useState } from "react";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageProvider";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Industries } from "@/components/Industries";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { Locations } from "@/components/Locations";
import { Careers } from "@/components/Careers";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { QuickLead } from "@/components/QuickLead";
import "@/App.css";

function App() {
  const [dark, setDark] = useState(() => {
    if (typeof window === "undefined") return false;
    const saved = window.localStorage.getItem("gwp_dark");
    return saved ? saved === "1" : false;
  });

  useEffect(() => {
    const root = document.documentElement;
    if (dark) root.classList.add("dark");
    else root.classList.remove("dark");
    window.localStorage.setItem("gwp_dark", dark ? "1" : "0");
  }, [dark]);

  return (
    <LanguageProvider>
      <div className="App relative min-h-screen overflow-x-hidden bg-background text-foreground">
        <Navbar dark={dark} setDark={setDark} />
        <main>
          <Hero />
          <About />
          <Services />
          <Industries />
          <WhyChooseUs />
          <Locations />
          <Careers />
          <Testimonials />
          <Contact />
        </main>
        <Footer />
        <QuickLead />
        <Toaster
          position="top-right"
          theme={dark ? "dark" : "light"}
          richColors
          closeButton
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
